import useNamespacedStorage from '../storage/useNamespacedStorage';

export default function useSelectedIsSuggested() {
  return useNamespacedStorage('ostroSelectedIsSuggested', false);
}
